class MultiVariantPopup extends HTMLElement {
  constructor() {
    super();
    this.overlay = null;
    this.content = null;
    this.closeButton = null;
    this.warningButton = null;
    this.boundEscHandler = this.handleEsc.bind(this);
    this.boundOutsideClickHandler = this.handleOutsideClick.bind(this);
  }

  connectedCallback() {
    this.overlay = this.querySelector('.popup-overlay');
    this.content = this.querySelector('.popup-content');
    this.closeButton = this.querySelector('.popup-close');
    this.warningButton = this.querySelector('.warning_button');

    if (!this.overlay || !this.content) {
      console.warn('Popup structure is incomplete inside <multi-variant-popup>');
      return;
    }

    // Set up listeners
    this.closeButton?.addEventListener('click', () => this.hide());
    this.warningButton?.addEventListener('click', () => this.handleWarningButton());
    this.overlay.addEventListener('click', this.boundOutsideClickHandler);
    document.addEventListener('keydown', this.boundEscHandler);

    // Listen to cart updates
    window.addEventListener('theme:cart:updated', () => this.checkCart());
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.boundEscHandler);
    this.overlay?.removeEventListener('click', this.boundOutsideClickHandler);
  }

  handleEsc(e) {
    if (e.key === 'Escape') this.hide();
  }

  handleOutsideClick(e) {
    if (!this.content.contains(e.target)) {
      this.hide();
    }
  }

  show() {
    this.overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  hide() {
    this.overlay.style.display = 'none';
    document.body.style.overflow = '';
  }

  handleWarningButton() {
    this.hide();

    // open sizekick drawer by clicking the app's opening button
    const sizekickbutton = document
      .querySelector("szk-widget-app")
      ?.shadowRoot.querySelector("szk-widget-find-size")
      ?.shadowRoot.querySelector("#find-size");

    if (sizekickbutton) sizekickbutton.click();
  }

  async checkCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      const productVariantsMap = {};

      cart.items.forEach(({ product_id, variant_id }) => {
        if (!productVariantsMap[product_id]) {
          productVariantsMap[product_id] = new Set();
        }
        productVariantsMap[product_id].add(variant_id);
      });

      const hasMultipleVariants = Object.values(productVariantsMap).some(
        set => set.size > 1
      );

      if (hasMultipleVariants) {
        this.show();
      }
    } catch (err) {
      console.error('Failed to check cart variants:', err);
    }
  }
}

customElements.define('multi-variant-popup', MultiVariantPopup);
